/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CategoryAmountDTO,
  CategoryAmountDTOOptional,
  CategoryAmountDTOMetaI,
  CategoryAmountDTOTrackedI,
} from "./category-amount-dto";
import {
  CategoryAmountDTOTracked,
  CategoryAmountDTOMeta,
} from "./category-amount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DailySummaryReportBase,
  DailySummaryReportBaseOptional,
  DailySummaryReportBaseMetaI,
  DailySummaryReportBaseTrackedI,
} from "./daily-summary-report-base";
import {
  DailySummaryReportBaseTracked,
  DailySummaryReportBaseMeta,
} from "./daily-summary-report-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DailySummaryReportDTO,
  DailySummaryReportDTOOptional,
  DailySummaryReportDTOMetaI,
  DailySummaryReportDTOTrackedI,
} from "./daily-summary-report-dto";
import {
  DailySummaryReportDTOTracked,
  DailySummaryReportDTOMeta,
} from "./daily-summary-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PaymentTypeAmountDTO,
  PaymentTypeAmountDTOOptional,
  PaymentTypeAmountDTOMetaI,
  PaymentTypeAmountDTOTrackedI,
} from "./payment-type-amount-dto";
import {
  PaymentTypeAmountDTOTracked,
  PaymentTypeAmountDTOMeta,
} from "./payment-type-amount-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface DailySummaryReportsDTO
 */
export interface DailySummaryReportsDTOOptional extends DailySummaryReportBaseOptional {
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalAmountItems?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalAmountPayments?: number;
  /**
   *
   * @type {Array<CategoryAmountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  categoryAmounts?: CategoryAmountDTOOptional[];
  /**
   *
   * @type {Array<PaymentTypeAmountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  paymentTypeAmounts?: PaymentTypeAmountDTOOptional[];
  /**
   *
   * @type {boolean}
   * @memberof DailySummaryReportsDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DailySummaryReportsDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof DailySummaryReportsDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof DailySummaryReportsDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof DailySummaryReportsDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof DailySummaryReportsDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof DailySummaryReportsDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof DailySummaryReportsDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {Array<DailySummaryReportDTO>}
   * @memberof DailySummaryReportsDTO
   */
  dailySummaryReports?: DailySummaryReportDTOOptional[];
  /**
   *
   * @type {Array<number>}
   * @memberof DailySummaryReportsDTO
   */
  badOrderIds?: number[];
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalOrders?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalItems?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalPayments?: number;
}

export interface DailySummaryReportsDTO
  extends DailySummaryReportsDTOOptional, DailySummaryReportBase, ReportDTO {
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalAmountItems?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalAmountPayments?: number;
  /**
   *
   * @type {Array<CategoryAmountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  categoryAmounts?: CategoryAmountDTO[];
  /**
   *
   * @type {Array<PaymentTypeAmountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  paymentTypeAmounts?: PaymentTypeAmountDTO[];
  /**
   *
   * @type {boolean}
   * @memberof DailySummaryReportsDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DailySummaryReportsDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof DailySummaryReportsDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof DailySummaryReportsDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof DailySummaryReportsDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof DailySummaryReportsDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof DailySummaryReportsDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof DailySummaryReportsDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {Array<DailySummaryReportDTO>}
   * @memberof DailySummaryReportsDTO
   */
  dailySummaryReports: DailySummaryReportDTO[];
  /**
   *
   * @type {Array<number>}
   * @memberof DailySummaryReportsDTO
   */
  badOrderIds?: number[];
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalOrders?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalItems?: number;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalPayments?: number;
}

export interface DailySummaryReportsDTOTrackedI extends DailySummaryReportBaseOptional {
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalAmountItems?: number;
  totalAmountItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalAmountPayments?: number;
  totalAmountPaymentsIsSet: boolean;
  /**
   *
   * @type {Array<CategoryAmountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  categoryAmounts?: CategoryAmountDTOTrackedI[];
  categoryAmountsIsSet: boolean;
  /**
   *
   * @type {Array<PaymentTypeAmountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  paymentTypeAmounts?: PaymentTypeAmountDTOTrackedI[];
  paymentTypeAmountsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DailySummaryReportsDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DailySummaryReportsDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DailySummaryReportsDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof DailySummaryReportsDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof DailySummaryReportsDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof DailySummaryReportsDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof DailySummaryReportsDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof DailySummaryReportsDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof DailySummaryReportsDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {Array<DailySummaryReportDTO>}
   * @memberof DailySummaryReportsDTO
   */
  dailySummaryReports?: DailySummaryReportDTOTrackedI[];
  dailySummaryReportsIsSet: boolean;
  /**
   *
   * @type {Array<number>}
   * @memberof DailySummaryReportsDTO
   */
  badOrderIds?: number[];
  badOrderIdsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalOrders?: number;
  totalOrdersIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalItems?: number;
  totalItemsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof DailySummaryReportsDTO
   */
  totalPayments?: number;
  totalPaymentsIsSet: boolean;
}

transformDatesMap.set(
  "DailySummaryReportsDTO",
  function (model: DailySummaryReportsDTO) {
    const transformDatescategoryAmounts =
      transformDatesMap.get("CategoryAmountDTO");
    if (transformDatescategoryAmounts) {
      model.categoryAmounts?.forEach((sub) => {
        transformDatescategoryAmounts(sub);
      });
    }
    const transformDatespaymentTypeAmounts = transformDatesMap.get(
      "PaymentTypeAmountDTO",
    );
    if (transformDatespaymentTypeAmounts) {
      model.paymentTypeAmounts?.forEach((sub) => {
        transformDatespaymentTypeAmounts(sub);
      });
    }
    const transformDateschildReports = transformDatesMap.get("ReportDTO");
    if (transformDateschildReports) {
      model.childReports?.forEach((sub) => {
        transformDateschildReports(sub);
      });
    }
    const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
    if (transformDatesmeta) {
      model.meta?.forEach((sub) => {
        transformDatesmeta(sub);
      });
    }
    const transformDatestypeCounts =
      transformDatesMap.get("ReportTypeCountDTO");
    if (transformDatestypeCounts) {
      model.typeCounts?.forEach((sub) => {
        transformDatestypeCounts(sub);
      });
    }
    const transformDatesdailySummaryReports = transformDatesMap.get(
      "DailySummaryReportDTO",
    );
    if (transformDatesdailySummaryReports) {
      model.dailySummaryReports?.forEach((sub) => {
        transformDatesdailySummaryReports(sub);
      });
    }
  },
);

export type DailySummaryReportsDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  totalAmountItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalAmountPayments: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  categoryAmounts: PropertyMeta<CategoryAmountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  paymentTypeAmounts: PropertyMeta<PaymentTypeAmountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  dailySummaryReports: PropertyMeta<DailySummaryReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  badOrderIds: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalOrders: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalItems: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalPayments: PropertyMeta<MetaTypeBase<number>>;
}>;

export var DailySummaryReportsDTOMeta: DailySummaryReportsDTOMetaI =
  {} as DailySummaryReportsDTOMetaI;
DailySummaryReportsDTOMeta = typeMeta("DailySummaryReportsDTO", {
  totalAmountItems: propertyMeta(
    "totalAmountItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalAmountPayments: propertyMeta(
    "totalAmountPayments",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  categoryAmounts: propertyMeta(
    "categoryAmounts",
    true,
    false,
    false,
    CategoryAmountDTOMeta,
  ),
  paymentTypeAmounts: propertyMeta(
    "paymentTypeAmounts",
    true,
    false,
    false,
    PaymentTypeAmountDTOMeta,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  dailySummaryReports: propertyMeta(
    "dailySummaryReports",
    true,
    true,
    false,
    DailySummaryReportDTOMeta,
  ),
  badOrderIds: propertyMeta(
    "badOrderIds",
    true,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalOrders: propertyMeta(
    "totalOrders",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalItems: propertyMeta(
    "totalItems",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalPayments: propertyMeta(
    "totalPayments",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = DailySummaryReportsDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DailySummaryReportBaseMeta]);
  metaI.totalAmountItems.inheritedFrom =
    DailySummaryReportBaseMeta.totalAmountItems;
  metaI.totalAmountPayments.inheritedFrom =
    DailySummaryReportBaseMeta.totalAmountPayments;
  metaI.categoryAmounts.inheritedFrom =
    DailySummaryReportBaseMeta.categoryAmounts;
  metaI.paymentTypeAmounts.inheritedFrom =
    DailySummaryReportBaseMeta.paymentTypeAmounts;
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
});

export class DailySummaryReportsDTOTracked
  extends DailySummaryReportBaseTracked
  implements DailySummaryReportsDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  totalAmountItems__I?: number = undefined;
  totalAmountItemsIsSet: boolean = false;
  set totalAmountItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountItems__I = v;
      this.totalAmountItemsIsSet = true;
    } else {
      this.totalAmountItems__I = v || undefined;
      this.totalAmountItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountItems() {
    return this.totalAmountItems__I;
  }
  totalAmountPayments__I?: number = undefined;
  totalAmountPaymentsIsSet: boolean = false;
  set totalAmountPayments(v: undefined | number) {
    if (v !== undefined) {
      this.totalAmountPayments__I = v;
      this.totalAmountPaymentsIsSet = true;
    } else {
      this.totalAmountPayments__I = v || undefined;
      this.totalAmountPaymentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalAmountPayments() {
    return this.totalAmountPayments__I;
  }
  categoryAmounts__I?: CategoryAmountDTOTracked[] = undefined;
  categoryAmountsIsSet: boolean = false;
  set categoryAmounts(v: undefined | CategoryAmountDTOTracked[]) {
    if (v !== undefined) {
      this.categoryAmounts__I = v;
      this.categoryAmountsIsSet = true;
    } else {
      this.categoryAmounts__I = v || undefined;
      this.categoryAmountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get categoryAmounts() {
    return this.categoryAmounts__I;
  }
  paymentTypeAmounts__I?: PaymentTypeAmountDTOTracked[] = undefined;
  paymentTypeAmountsIsSet: boolean = false;
  set paymentTypeAmounts(v: undefined | PaymentTypeAmountDTOTracked[]) {
    if (v !== undefined) {
      this.paymentTypeAmounts__I = v;
      this.paymentTypeAmountsIsSet = true;
    } else {
      this.paymentTypeAmounts__I = v || undefined;
      this.paymentTypeAmountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get paymentTypeAmounts() {
    return this.paymentTypeAmounts__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  dailySummaryReports__I?: DailySummaryReportDTOTracked[] = undefined;
  dailySummaryReportsIsSet: boolean = false;
  set dailySummaryReports(v: undefined | DailySummaryReportDTOTracked[]) {
    if (v !== undefined) {
      this.dailySummaryReports__I = v;
      this.dailySummaryReportsIsSet = true;
    } else {
      this.dailySummaryReports__I = v || undefined;
      this.dailySummaryReportsIsSet = true;
    }
    this.changeTracker = true;
  }
  get dailySummaryReports() {
    return this.dailySummaryReports__I;
  }
  badOrderIds__I?: number[] = undefined;
  badOrderIdsIsSet: boolean = false;
  set badOrderIds(v: undefined | number[]) {
    if (v !== undefined) {
      this.badOrderIds__I = v;
      this.badOrderIdsIsSet = true;
    } else {
      this.badOrderIds__I = v || undefined;
      this.badOrderIdsIsSet = false;
    }
    this.changeTracker = true;
  }
  get badOrderIds() {
    return this.badOrderIds__I;
  }
  totalOrders__I?: number = undefined;
  totalOrdersIsSet: boolean = false;
  set totalOrders(v: undefined | number) {
    if (v !== undefined) {
      this.totalOrders__I = v;
      this.totalOrdersIsSet = true;
    } else {
      this.totalOrders__I = v || undefined;
      this.totalOrdersIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalOrders() {
    return this.totalOrders__I;
  }
  totalItems__I?: number = undefined;
  totalItemsIsSet: boolean = false;
  set totalItems(v: undefined | number) {
    if (v !== undefined) {
      this.totalItems__I = v;
      this.totalItemsIsSet = true;
    } else {
      this.totalItems__I = v || undefined;
      this.totalItemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalItems() {
    return this.totalItems__I;
  }
  totalPayments__I?: number = undefined;
  totalPaymentsIsSet: boolean = false;
  set totalPayments(v: undefined | number) {
    if (v !== undefined) {
      this.totalPayments__I = v;
      this.totalPaymentsIsSet = true;
    } else {
      this.totalPayments__I = v || undefined;
      this.totalPaymentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalPayments() {
    return this.totalPayments__I;
  }
  constructor(
    config?: DailySummaryReportsDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    this.categoryAmounts?.forEach((a) => a.setIds());

    this.paymentTypeAmounts?.forEach((a) => a.setIds());

    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    this.dailySummaryReports?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: DailySummaryReportsDTOOptional,
    options?: AssignOptions,
  ): DailySummaryReportsDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.totalAmountItems &&
      this.totalAmountItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountItems = config.totalAmountItems;
      if (optionsRequired.unassign) this.totalAmountItemsIsSet = false;
      else this.totalAmountItemsIsSet = true;
    }
    if (
      config.totalAmountPayments &&
      this.totalAmountPaymentsApplyFilter(optionsRequired.filter)
    ) {
      this.totalAmountPayments = config.totalAmountPayments;
      if (optionsRequired.unassign) this.totalAmountPaymentsIsSet = false;
      else this.totalAmountPaymentsIsSet = true;
    }
    if (
      config.categoryAmounts &&
      this.categoryAmountsApplyFilter(optionsRequired.filter)
    ) {
      this.categoryAmounts = config.categoryAmounts?.map(
        (a) => new CategoryAmountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.categoryAmountsIsSet = false;
      else this.categoryAmountsIsSet = true;
    }
    if (
      config.paymentTypeAmounts &&
      this.paymentTypeAmountsApplyFilter(optionsRequired.filter)
    ) {
      this.paymentTypeAmounts = config.paymentTypeAmounts?.map(
        (a) => new PaymentTypeAmountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.paymentTypeAmountsIsSet = false;
      else this.paymentTypeAmountsIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.dailySummaryReports &&
      this.dailySummaryReportsApplyFilter(optionsRequired.filter)
    ) {
      this.dailySummaryReports = config.dailySummaryReports?.map(
        (a) => new DailySummaryReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.dailySummaryReportsIsSet = false;
      else this.dailySummaryReportsIsSet = true;
    }
    if (
      config.badOrderIds &&
      this.badOrderIdsApplyFilter(optionsRequired.filter)
    ) {
      this.badOrderIds = config.badOrderIds;
      if (optionsRequired.unassign) this.badOrderIdsIsSet = false;
      else this.badOrderIdsIsSet = true;
    }
    if (
      config.totalOrders &&
      this.totalOrdersApplyFilter(optionsRequired.filter)
    ) {
      this.totalOrders = config.totalOrders;
      if (optionsRequired.unassign) this.totalOrdersIsSet = false;
      else this.totalOrdersIsSet = true;
    }
    if (
      config.totalItems &&
      this.totalItemsApplyFilter(optionsRequired.filter)
    ) {
      this.totalItems = config.totalItems;
      if (optionsRequired.unassign) this.totalItemsIsSet = false;
      else this.totalItemsIsSet = true;
    }
    if (
      config.totalPayments &&
      this.totalPaymentsApplyFilter(optionsRequired.filter)
    ) {
      this.totalPayments = config.totalPayments;
      if (optionsRequired.unassign) this.totalPaymentsIsSet = false;
      else this.totalPaymentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DailySummaryReportsDTOTrackedI {
    const cloned = {} as DailySummaryReportsDTOTrackedI;
    if (
      this.totalAmountItemsIsSetDeep() &&
      this.totalAmountItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountItemsIsSet = true;
      cloned.totalAmountItems = this.totalAmountItems;
    } else {
      //cloned.totalAmountItemsIsSet = false
    }
    if (
      this.totalAmountPaymentsIsSetDeep() &&
      this.totalAmountPaymentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalAmountPaymentsIsSet = true;
      cloned.totalAmountPayments = this.totalAmountPayments;
    } else {
      //cloned.totalAmountPaymentsIsSet = false
    }
    if (
      this.categoryAmountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.categoryAmountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryAmountsIsSet = true;
      cloned.categoryAmounts = this.categoryAmounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.categoryAmountsIsSet = false
    }
    if (
      this.paymentTypeAmountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.paymentTypeAmountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentTypeAmountsIsSet = true;
      cloned.paymentTypeAmounts = this.paymentTypeAmounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.paymentTypeAmountsIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.dailySummaryReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.dailySummaryReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dailySummaryReportsIsSet = true;
      cloned.dailySummaryReports = this.dailySummaryReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.dailySummaryReportsIsSet = false
    }
    if (
      this.badOrderIdsIsSetDeep() &&
      this.badOrderIdsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.badOrderIdsIsSet = true;
      cloned.badOrderIds = this.badOrderIds;
    } else {
      //cloned.badOrderIdsIsSet = false
    }
    if (
      this.totalOrdersIsSetDeep() &&
      this.totalOrdersApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalOrdersIsSet = true;
      cloned.totalOrders = this.totalOrders;
    } else {
      //cloned.totalOrdersIsSet = false
    }
    if (
      this.totalItemsIsSetDeep() &&
      this.totalItemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalItemsIsSet = true;
      cloned.totalItems = this.totalItems;
    } else {
      //cloned.totalItemsIsSet = false
    }
    if (
      this.totalPaymentsIsSetDeep() &&
      this.totalPaymentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalPaymentsIsSet = true;
      cloned.totalPayments = this.totalPayments;
    } else {
      //cloned.totalPaymentsIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DailySummaryReportsDTOTrackedI {
    if (!this.totalAmountItemsApplyFilter(filter))
      this.totalAmountItemsIsSet = false;

    if (!this.totalAmountPaymentsApplyFilter(filter))
      this.totalAmountPaymentsIsSet = false;

    if (!this.categoryAmountsApplyFilter(filter))
      this.categoryAmountsIsSet = false;

    this.categoryAmounts?.forEach((a) => a.unassignAll(filter));
    if (!this.paymentTypeAmountsApplyFilter(filter))
      this.paymentTypeAmountsIsSet = false;

    this.paymentTypeAmounts?.forEach((a) => a.unassignAll(filter));
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.dailySummaryReportsApplyFilter(filter))
      this.dailySummaryReportsIsSet = false;

    this.dailySummaryReports?.forEach((a) => a.unassignAll(filter));
    if (!this.badOrderIdsApplyFilter(filter)) this.badOrderIdsIsSet = false;

    if (!this.totalOrdersApplyFilter(filter)) this.totalOrdersIsSet = false;

    if (!this.totalItemsApplyFilter(filter)) this.totalItemsIsSet = false;

    if (!this.totalPaymentsApplyFilter(filter)) this.totalPaymentsIsSet = false;

    return this;
  }
  totalAmountItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.totalAmountItems,
      DailySummaryReportsDTOMeta,
      this.totalAmountItems,
      this,
    );
  }
  totalAmountItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalAmountItemsIsSet && this.totalAmountItemsApplyFilter(filter))
      return true;

    return false;
  }
  totalAmountPaymentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.totalAmountPayments,
      DailySummaryReportsDTOMeta,
      this.totalAmountPayments,
      this,
    );
  }
  totalAmountPaymentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.totalAmountPaymentsIsSet &&
      this.totalAmountPaymentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  categoryAmountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.categoryAmounts,
      DailySummaryReportsDTOMeta,
      this.categoryAmounts,
      this,
    );
  }
  categoryAmountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryAmountsIsSet && this.categoryAmountsApplyFilter(filter))
      return true;

    return this.categoryAmounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  paymentTypeAmountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.paymentTypeAmounts,
      DailySummaryReportsDTOMeta,
      this.paymentTypeAmounts,
      this,
    );
  }
  paymentTypeAmountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.paymentTypeAmountsIsSet &&
      this.paymentTypeAmountsApplyFilter(filter)
    )
      return true;

    return this.paymentTypeAmounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.isDeleted,
      DailySummaryReportsDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.isNew,
      DailySummaryReportsDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.reportId,
      DailySummaryReportsDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.reportKey,
      DailySummaryReportsDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.reportTitle,
      DailySummaryReportsDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.reportType,
      DailySummaryReportsDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.reportStatus,
      DailySummaryReportsDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.childReports,
      DailySummaryReportsDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.meta,
      DailySummaryReportsDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.typeCounts,
      DailySummaryReportsDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  dailySummaryReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.dailySummaryReports,
      DailySummaryReportsDTOMeta,
      this.dailySummaryReports,
      this,
    );
  }
  dailySummaryReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.dailySummaryReportsIsSet &&
      this.dailySummaryReportsApplyFilter(filter)
    )
      return true;

    return this.dailySummaryReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  badOrderIdsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.badOrderIds,
      DailySummaryReportsDTOMeta,
      this.badOrderIds,
      this,
    );
  }
  badOrderIdsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.badOrderIdsIsSet && this.badOrderIdsApplyFilter(filter))
      return true;

    return false;
  }
  totalOrdersApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.totalOrders,
      DailySummaryReportsDTOMeta,
      this.totalOrders,
      this,
    );
  }
  totalOrdersIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalOrdersIsSet && this.totalOrdersApplyFilter(filter))
      return true;

    return false;
  }
  totalItemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.totalItems,
      DailySummaryReportsDTOMeta,
      this.totalItems,
      this,
    );
  }
  totalItemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalItemsIsSet && this.totalItemsApplyFilter(filter)) return true;

    return false;
  }
  totalPaymentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DailySummaryReportsDTOMeta.totalPayments,
      DailySummaryReportsDTOMeta,
      this.totalPayments,
      this,
    );
  }
  totalPaymentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalPaymentsIsSet && this.totalPaymentsApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.totalAmountItemsIsSetDeep(filter)) return true;
    if (this.totalAmountPaymentsIsSetDeep(filter)) return true;
    if (this.categoryAmountsIsSetDeep(filter)) return true;
    if (this.paymentTypeAmountsIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.dailySummaryReportsIsSetDeep(filter)) return true;
    if (this.badOrderIdsIsSetDeep(filter)) return true;
    if (this.totalOrdersIsSetDeep(filter)) return true;
    if (this.totalItemsIsSetDeep(filter)) return true;
    if (this.totalPaymentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
